import { useEffect, useRef } from 'react';

import { GTAG_IDS, GTM_IDS } from '../constants';
import { useLocale } from '../contexts';

export default function useGTM() {
  const initialized = useRef<boolean>(false);

  const { language } = useLocale('shared');

  useEffect(() => {
    const gtmId = GTM_IDS[language];
    const gtagId = GTAG_IDS[language];

    if (initialized.current) return;

    if (gtmId) {
      addGtmScript(gtmId);
    }

    if (gtagId) {
      addGtagScript(gtagId);
    }

    initialized.current = true;
  }, [language]);
}

function addGtmScript(id: string) {
  const elementId = `gtm-${id}`;

  const scriptExists = document.getElementById(elementId);

  if (scriptExists) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.id = elementId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;

  document.head.appendChild(script);
}

function addGtagScript(id: string) {
  const elementId = `gtag-${id}`;

  const scriptExists = document.getElementById(elementId);

  if (scriptExists) return;

  const script = document.createElement('script');
  script.id = elementId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

  document.head.appendChild(script);

  if (!window.gtag) return;

  window.gtag('js', new Date());

  window.gtag('config', id);
}
